export const MAX_HABIT_TAGS = 20
export const MAX_HABIT_TAG_LENGTH = 32

/**
 * Normalizes a habit tag list: trimmed strings with collapsed whitespace,
 * capped in length and count, de-duplicated case-insensitively (the first
 * spelling wins).
 *
 * @param value - The candidate list.
 * @returns The normalized tags.
 */
export function normalizeHabitTags(value: unknown): string[] {
   if (!Array.isArray(value)) {
      return []
   }
   const seen = new Set<string>()
   const tags: string[] = []
   for (const entry of value) {
      if (typeof entry !== 'string') {
         continue
      }
      const tag = entry.trim().replace(/\s+/g, ' ').slice(0, MAX_HABIT_TAG_LENGTH).trim()
      const key = tag.toLowerCase()
      if (tag && !seen.has(key)) {
         seen.add(key)
         tags.push(tag)
      }
   }
   return tags.slice(0, MAX_HABIT_TAGS)
}

/**
 * Returns whether a tag list contains a tag, ignoring case.
 *
 * @param tags - The habit's tags.
 * @param tag - The tag to look for.
 * @returns True when present.
 */
export function habitHasTag(tags: readonly string[], tag: string) {
   const key = tag.trim().toLowerCase()
   return tags.some(candidate => candidate.toLowerCase() === key)
}
